
export function send(data) {
    if (!window.app.socket) {
        console.error('Failed to send ws event - socket does not exist')
        return
    }
    if (window.app.socket.readyState !== 1) {
        console.error('Failed to send ws event')
        return
    }
    window.app.socket.send(JSON.stringify(data))
}

